import Image, { type ImageProps, type StaticImageData } from 'next/image';
import GoogleSvg from 'public/img/icons/google.svg';
import GoogleDisabledSvg from 'public/img/icons/google-disabled.svg';

interface Props extends Omit<ImageProps, 'alt' | 'src'> {
  disabled?: boolean;
}

export const GoogleIcon = ({ disabled = false, ...props }: Props) => {
  return (
    <Image
      alt="Folder icon"
      width={20}
      src={(disabled ? GoogleDisabledSvg : GoogleSvg) as StaticImageData}
      {...props}
    />
  );
};
